<template>
    <div class="stf-body">
        <slot />
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
@use '@/assets/sass/_variables' as vars;
@use "bulma/sass/utilities/mixins";

.stf-body {
  font-family: vars.$font-family-primary;
  font-weight: vars.$font-weight-normal;
  font-size: vars.$font-size-14;
  letter-spacing: 0;
  color: #414141;

  @include mixins.mobile {
    font-size: vars.$font-size-12;
  }
}
</style>
